import { FlexBox, SPACING, Typography, UserRole } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useShallow } from "zustand/react/shallow"

import { useCatchUpCompleteStore } from "./useCatchUpCompleteStore"
import { useUserQuery } from "../../networking/queries"

const CatchUpCompleteEmptyState = () => {
  const { selectedUserProfile } = useCatchUpCompleteStore(
    useShallow((state) => ({ selectedUserProfile: state.selectedUserProfile }))
  )
  const { user } = useUserQuery()
  const { t } = useTranslation()

  const isSelfSelected = selectedUserProfile?.user.id === user?.id
  const isCoparent =
    selectedUserProfile?.role === UserRole.PARENT && !isSelfSelected

  return (
    <FlexBox
      direction="column"
      justify="flex-start"
      align="center"
      style={{
        height: "min(600px, calc(100vh - 80px))",
        padding: `${SPACING.space6}`,
      }}
    >
      <div className="flex flex-col items-center gap-2">
        <img
          src="/images/party_popper.gif"
          alt="party-popper"
          className="w-16 h-16 my-4"
        />
        <Typography variant="bodyBold" textAlign="center">
          {isSelfSelected
            ? t("CATCHUP_REVIEWED_ALL_SELF")
            : t("CATCHUP_REVIEWED_ALL_OTHER", {
                name: selectedUserProfile?.user.name,
              })}
        </Typography>
        {!isSelfSelected && !isCoparent && (
          <>
            <Typography variant="bodySmall" textAlign="center">
              {t("CATCHUP_EARNED_COINS")}
            </Typography>
            <img
              src="/images/redeem_from_mailman.png"
              alt="redeem-from-mailman"
              className="w-full"
            />
          </>
        )}
      </div>
    </FlexBox>
  )
}

export default CatchUpCompleteEmptyState
